import { render, staticRenderFns } from "./PostSearchHeader.vue?vue&type=template&id=0c441368&scoped=true"
import script from "./PostSearchHeader.vue?vue&type=script&lang=js"
export * from "./PostSearchHeader.vue?vue&type=script&lang=js"
import style0 from "./PostSearchHeader.vue?vue&type=style&index=0&id=0c441368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c441368",
  null
  
)

export default component.exports